import axios from 'axios';
import { getLocalStorage } from './localStorage';
import React, { useEffect, useState, useRef } from 'react';
export const setHeaderAuth = async () => {
  const token = await getLocalStorage('token');
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};
